import { ComposedTheme, createUseStyles } from '@glu/theming';

export default createUseStyles(({ accordion }: ComposedTheme) => ({
  parentSection: {
    ...accordion.parentSection,
  },
  nestedSection: {
    ...accordion.nestedSection,
  },
}));
